import type { FieldPath, FieldValues } from 'react-hook-form'
import type { Style } from 'inlines'
import { Select } from '../../input/select/Select'
import { FormField } from '../FormField'

export type SelectFieldProps<
  T extends FieldValues = FieldValues,
  V extends string | number = string,
> = {
  name: FieldPath<T>
  label?: string
  labelStyle?: Style
  options: { value: V; label: string }[]
  notSelectedLabel?: string
  variant?: 'outlined' | 'muted-blue'
}

export const SelectField = <
  T extends FieldValues = FieldValues,
  V extends string | number = string,
>({
  name,
  ...selectProps
}: SelectFieldProps<T, V>) => {
  return (
    <FormField<T>
      name={name}
      render={({ value, onChange, onBlur, errorMessage }) => (
        <Select<V>
          {...selectProps}
          value={(value as V) ?? null}
          setValue={onChange}
          onBlur={onBlur}
          errorMessage={errorMessage}
        />
      )}
    />
  )
}
